import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Spinner } from 'src/app/core/services/spinner.service';
import { GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD, GeTagRequest } from 'src/app/shared/model/ge-tag-request-form.module';
import { GeTagRequestFormService } from 'src/app/shared/service/ge-tag-request-form.service';
import { UploadFile } from 'src/app/shared/model/file.model';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { ConfirmationDialogComponent } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { SubscriptionLike } from 'rxjs';
import { TicketRequest } from 'src/app/shared/model/ticket-access-request.model';

@Component({
  selector: 'app-ge-tag-request-form',
  templateUrl: './ge-tag-request-form.component.html',
  styleUrls: ['./ge-tag-request-form.component.scss']
})
export class GeTagRequestFormComponent implements OnInit {

  @ViewChild('fileInput') fileInput;
  geTagRequest: GeTagRequest = new GeTagRequest();
  geTagRequestForm: FormGroup;
  minDate: Date;
  fileName: string = '';
  fileData: any;
  fileNotUploaded: boolean = false;
  request: TicketRequest[] = [];
  returned: TicketRequest[] = [];
  subscription: SubscriptionLike;
  comments: string;
  
  constructor(
    private spinner: Spinner,
    private fb: FormBuilder,
    private toastService: ToastrService,
    private dialog: MatDialog,
    private service: GeTagRequestFormService
  ) { 
    const today = new Date();
    this.minDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() +1);
  }

  types = ['Y', 'N'];
  optionList = ['OnShore Wind', 'OffShore Wind'];
  tagStyleTypes = ['Standard Tag - 4.5 inches x 2 inches ROLL-10-1','Small Tag - 4.5 inches x 1.25 inches (vibe monitor only) ROLL-20206-1','3-Tag Kit (Blades only) ROLL-20207-1'];

  ngOnInit() {
    this.initFormGeTagRequest();
    this.getListTicket();
    this.getReturnedTicket();
  }

  goToGuide(){
    window.open('../../../../../assets/pdf-register/GE-Tag-ID-External-Guide.pdf', '_blank');
  }

  tagRequestTemplate() {
    window.open('../../../../../assets/documents/Supplier_Tag_Request_Template_2024_10_1.xlsx', '_blank');
  }

  clearUsers(){
    window.open('https://libraries.ge.com/download?fileid=669653947101&entity_id=10492347101&sid=101', '_blank');
  }

  nonClearUsers(){
    window.open('https://libraries.ge.com/download?fileid=669655098101&entity_id=10492347101&sid=101', '_blank');
  }

  public onFileInput(event) {
    const fileTypes = ['png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
    const file = event.target.files[0];
    this.fileName = file.name;
    const uploadFile = new UploadFile(file, false);
    if (uploadFile.file.size > 10485760) {
      this.toastService.error(
        MESSAGE_TOAST.ERROR_CHOOSE_FILE_DOC_SIZE
      );
    } else if (fileTypes.filter(item => item === uploadFile.type).length === 0) {
      this.toastService.error(
        MESSAGE_TOAST.ERROR_CHOOSE_FILE_DOC
      );
    } else {
      this.uploadAttachment(file);
    }
  }

  uploadAttachment(inputFile: File) {
    if (!inputFile) {
      return;
    }
    this.spinner.show();
    this.service.uploadAttachment(inputFile).subscribe(response => {
      if(response.status === 200){
        this.fileData = response.data;
        if(this.fileNotUploaded){
          this.fileNotUploaded = false;
        }
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.toastService.error(MESSAGE_TOAST.ERROR__FILE_UPLOAD);
      }
      
    });
  }

  public removeAttachment() {
    this.fileName = '';
    this.fileInput.nativeElement.value = '';
    this.fileData = null;
    this.fileNotUploaded = true;
  }

  initFormGeTagRequest(){
    return this.geTagRequestForm = this.fb.group({
      supplierName: [this.geTagRequest.supplierName, [Validators.required]],
      gslNumber: [this.geTagRequest.gslNumber, [Validators.required]],
      isNewSupplier: [this.geTagRequest.isNewSupplier, [Validators.required]],
      date: [this.geTagRequest.date, [Validators.required]],
      shipToAddress: [this.geTagRequest.shipToAddress, [Validators.required]],
      shipToCity: [this.geTagRequest.shipToCity, [Validators.required]],
      shipToState: [this.geTagRequest.shipToState, [Validators.required]],
      shipToZip: [this.geTagRequest.shipToZip, [Validators.required]],
      country: [this.geTagRequest.country, [Validators.required]],
      requestorComments: [this.geTagRequest.requestorComments],
      business: [this.geTagRequest.business, [Validators.required]],
      tagStyle: [this.geTagRequest.tagStyle ? this.geTagRequest.tagStyle : 'Standard Tag - 4.5 inches x 2 inches ROLL-10-1', [Validators.required]],
      buyerName: [this.geTagRequest.buyerName],
      shipToContactName: [this.geTagRequest.shipToContactName, [Validators.required]],
      phoneNumber: [this.geTagRequest.phoneNumber, [Validators.required]],
      emailAddress: [this.geTagRequest.emailAddress, [Validators.required]],
      requestId: [this.geTagRequest.requestId]
    });
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  submitGeTagRequestForm() {
    if (this.geTagRequestForm.valid && this.fileData) {
      this.openDialog();
    } else {
      this.markFormGroupTouched(this.geTagRequestForm);
      if (!this.fileData) {
        this.fileNotUploaded = true;
      }
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: MESSAGE_TOAST.CONFIRM_TAG_STATUS,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        const body = new GeTagRequest(this.geTagRequestForm.getRawValue(), false).convertToReqBody();
        body[GE_TAG_FORM_REQUEST_FE_BE_MAPPING_FIELD.file] = this.fileData;
        console.log(body);
        this.spinner.show();
        this.service.createRequestFormData(body).subscribe((res) => {
          console.log(res);
          this.spinner.hide();
          this.toastService.success(MESSAGE_TOAST.REQUEST_ACCESS_TICKET_SUCCESS);
          setTimeout(() => {
            location.reload();
          }, 3000);
        });
      }
    });
  }

  getListTicket(event?) {
    if (event) {
      event.srcElement.classList.remove('rotate');
      setTimeout(() => {
        event.srcElement.classList.add('rotate');
      }, 0);
    }
    this.subscription = this.service.getRequestAccessList().subscribe((res) => {
      this.request = res.data;
    }, (err) => {});
  }

  getReturnedTicket(event?) {
    if (event) {
      event.srcElement.classList.remove('rotate');
      setTimeout(() => {
        event.srcElement.classList.add('rotate');
      }, 0);
    }
    this.service.getReturnedList().subscribe((res) => {
      this.returned = res.data;
    }, (err) => {});
  }

  ngOnDestroy() {
    // unsubscribe
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onRecordClick(recordId: string) {
    this.service.getRecordDetails(recordId).subscribe((res: any) => {
      if (res && res.data) {
        const data = res.data;
        this.comments = res.data.comments;
        this.geTagRequestForm.patchValue({
          supplierName: data.supplierName,
          gslNumber: data.gslNumber,
          isNewSupplier: data.isNewSupplier,
          date: data.date,
          shipToAddress: data.shipToAddress,
          shipToCity: data.shipToCity,
          shipToState: data.shipToState,
          shipToZip: data.shipToZip,
          country: data.country,
          requestorComments: data.requestorComments,
          business: data.business,
          tagStyle: data.tagStyle,
          buyerName: data.buyerName,
          shipToContactName: data.shipToContactName,
          phoneNumber: data.phoneNumber,
          emailAddress: data.emailAddress,
          requestId: data.requestId
        });
      }
    });
  }
}

